export default __webpack_public_path__ + "static/hero-2-862158d78ff9d1285f3ac4f6e7e0d087.jpg";